import { ColorsEnum } from "../../core/et3-theme/colors";

const ALPHA_HAIRLINE = "14";
const ALPHA_TINT = "14";
const ALPHA_HOVER = "24";

export const PROFILE_PANEL_WIDTH = 340;
export const PROFILE_PANEL_RADIUS = 16;
export const PROFILE_PANEL_PADDING = 18;
export const PROFILE_PANEL_GAP = 14;

export const PROFILE_IDENTITY_GAP = 12;
export const PROFILE_AVATAR_SIZE = 42;
export const PROFILE_NAME_FONT_SIZE = 18;
export const PROFILE_ROLE_FONT_SIZE = 13;
export const PROFILE_ROLE_PADDING_X = 8;
export const PROFILE_ROLE_HEIGHT = 20;
export const PROFILE_ROLE_RADIUS = 6;

export const PROFILE_META_ROW_HEIGHT = 26;
export const PROFILE_META_GAP = 6;
export const PROFILE_LABEL_FONT_SIZE = 13;
export const PROFILE_VALUE_FONT_SIZE = 14;

export const PROFILE_ACTION_HEIGHT = 40;
export const PROFILE_ACTION_RADIUS = 10;
export const PROFILE_ACTION_GAP = 8;
export const PROFILE_ACTION_FONT_SIZE = 15;
export const PROFILE_ACTION_ICON_SIZE = 13;

export const PROFILE_DIVIDER_HEIGHT = 1;
export const PROFILE_DIVIDER = `${ColorsEnum.maastrichtBlue}${ALPHA_HAIRLINE}`;
export const PROFILE_ROLE_BACKGROUND = `${ColorsEnum.bondiBlue}${ALPHA_TINT}`;
export const PROFILE_SECONDARY_BORDER = `1px solid ${ColorsEnum.maastrichtBlue}${ALPHA_HOVER}`;
export const PROFILE_SECONDARY_HOVER = `${ColorsEnum.maastrichtBlue}${ALPHA_TINT}`;
export const PROFILE_DANGER_BACKGROUND = `${ColorsEnum.red}${ALPHA_TINT}`;
export const PROFILE_DANGER_HOVER = `${ColorsEnum.red}${ALPHA_HOVER}`;
export const PROFILE_PANEL_SHADOW = `0 16px 40px ${ColorsEnum.maastrichtBlue}29`;
export const PROFILE_TRANSITION =
  "background-color 160ms cubic-bezier(0.4, 0, 0.2, 1)";
